module.exports = __webpack_public_path__ + "static/media/location (2).3ec2afd7.svg";